export default {
  title: "Validación / Envío Archivos"
  , form: {
    id: { th: "ID" }
    , fecha: { th: "Fecha" }
    , estatus: { th: "Estado" }
    , subtipo: { th: "Canal" }
    , nombre: { th: "Nombre del Archivo" }
    , registros: { th: "Registros" }
    , usuarioalta: { th: "Usuario" }
    , enviarsft: { label: "Enviar al SFT" }
  }
  , detalle: {
    nombre: "Nombre del Archivo"
    , fecha: "Fecha"
    , subtipo: "Canal"
    , id: "ID"
    , total: "Total registros validados"
    , totalError: "Registros inválidos"
    , totalOk: "Registros validos"
    , duration: "Duración del proceso"
  }
  , buttons: {
    log: "Descargar Errores"
    , retry: "Reenviar"
  }
  , filters: {
    id: "ID"
    , subtipo: "Canal"
    , estatus: "Estado"
    , fecha: "Fecha"
    , username: "Usuario"
    , mailsent: "Enviado a Email"
  }
  , errors: {
    BD7000: { text: "Ocurrió un error en el módulo de validación" }
    , WS7000: { text: "Ocurrió un error en el módulo de validación" }
    , JS7000: { text: "Ocurrió un error en el módulo de validación" }
    , CR7000: { text: "Ocurrió un error en el módulo de validación" }
    , VL0000: { text: "El nombre del archivo debe corresponder al canal que se validara" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/filetransaction/validator.js